const zh = {
  teacher_login: '教师登录',
  login_out: '退出',
  back_home: '返回首页',
  back: '返回',
  activity_dynamics: '校区动态',
  activity_events: '活动赛事',
  activity_students: '学员风采',
  activity_public: '公益课程',
  about_us: '关于我们',
  about_agent: 'FAQ',
  about_join: '学员点评',
  about_business: '商学院',
  down_title: '上课软件下载',
  down_usepc: '使用电脑上课',
  down_google: '推荐使用谷歌浏览器',
  down_system: 'Windows7及以上系统/Mac OS 系统',
  down_button: '立即下载',
  release_time: '发布时间',
  teacher_username: '请输入账号',
  teacher_password: '请输入密码',
  teacher_sign: '立即登陆',
  time_setting: '设置课程',
  teacher_course: '我的课程',
  teacher_group: '上课班级',
  teacher_assignment: '课堂作业',
  teacher_profile: '个人资料',
  teacher_rules: '规则消息',
  profile: '个人资料',
  hours_amount: '课时费',
  view_comment: '学生点评',
  change_password: '修改密码',
  teacher_report: '数据统计',
  teacher_schedule: '课程表',
  teacher_enter_class: '教师可以提前进入教室准备每节课',
  teacher_none: '暂无数据',
  none: '暂无记录',
  course_stand: '待上课',
  course_finished: '已上课',
  course_finished_month: '本月已上课',
  group: '班级',
  student_number: '学生数量',
  people: '人',
  pregress_note: '进度',
  message: '信息',
  material: '课件',
  material2: '课件',
  feedback: '反馈',
  enter_classroom: '进入教室',
  record: '回放',
  click_record: '查看回放',
  edit_attandeny: '编辑点名',
  checking_attandeny: '上课点名',
  edit: '编辑',
  students: '学生',
  old_password: '原密码',
  new_password: '新密码',
  confirm_password: '确认密码',
  cancel: '取消',
  username: '登录帐号',
  teacher_name: '老师姓名',
  contact: '联系方式',
  gender: '性别',
  female: '女',
  male: '男',
  save: '保存',
  today: '今天',
  month: '月',
  week: '周',
  day: '天',
  list: '列表',
  setup_homework: '布置作业',
  date: '时间',
  detail: '详情',
  delete: '删除',
  search: '关键词',
  keyword: '关键词',
  start: '开始',
  end: '结束',
  topic: '标题',
  content: '内容',
  upload_picture_message: '只接受 jpg/png 文件，不能超过2mb 以及9张图片',
  upload_video_message: '只接受 mp4文件，不能超过50mb 以及4个视频',
  upload_video_no: '你的浏览器不支持视频',
  video: '视频',
  upload: '上传',
  edit_homework: '编辑作业',
  homework_detail: '班级作业详情',
  homework_comment: '老师点评',
  homework_comment_score: '作业评分',
  homework_comment_content: '评价内容',
  homework_comment_btn: '点评作业',
  group_list: '任课班级',
  lesson_number: '课时数',
  lesson: '课时',
  school_code: '机构',
  call_detail: '点名记录',
  attandency: '应到',
  present: '实到',
  amount: '合计',
  group_history: '班级进度',
  submit: '提交',
  all: '共',
  number: '条',
  go: '前往',
  page: '页',
  class_remarks: '课后反馈',
  files: '课件',
  cancel_class: '取消',
  cancel_class_title: '取消课程',
  cancel_class_note: '取消备注',
  cancel_class_picture: '上传证明',
  cancel_class_type: '取消原因',
  class_sign_in: '上课签到',
  signed_in: '已签到',
  cs_help: '求助',
  note: '内容',
  help_class_type: '类型',
  teacher_home: '个人中心',
  Review_Display: '学员评价',
  Problem_Feedback: '问题反馈',
  TM_Feedback: 'TM反馈',
  teacher_contract: '合同'
}
export default zh



// WEBPACK FOOTER //
// ./src/lang/zh.js